<template>
</template>
<script>
    export default {
      data() {
        return {
          ueditor_flag: false,
          description: window.localStorage.getItem('description'),
        };
      },
      methods:{
        jw_enter(){
          console.log('跳转参数', this.$route.params)
          if (this.$route.params.mock_id) {
            this.$api.GETEXERCISERECORDINFOFORMOCK({
              exercise_id: this.$route.params.exercise_id,
              mock_id: this.$route.params.mock_id,
              paper_id: this.$route.params.paper_id,
              sso_id: this.$route.params.sso_id,
              correct_user: this.$route.params.correct_user,
              record_id: this.$route.params.record_id,
              correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
            }).then((res) => {
              console.log('返回数据', res.data)
              console.log('模考跳转接口：/api/admin/exercise/getExerciseRecordInfoForMock')
              if(res.retcode == 0){
                const view = this.$router.resolve({
                  path: `/homework-mock/${res.data.object_id}/${res.data.record_id}/${res.data.tiku_user_id}/${res.data.object_type}/${res.data.exercise_id}/${res.data.assign_correct_user}/${res.data.sso_id}/0/''/0/${res.data.is_release}/${res.data.is_reject}?homework_type=${res.data.homework_type}&correct_from=${res.data.correct_from}`
                })
                window.location.href = view.href
              } else {
                alert(res.message)
              }
            })
          } else {
            this.$api.GETEXERCISERECORDINFO({
              paper_id: this.$route.params.paper_id,
              practice_id: this.$route.params.practice_id,
              phone: this.$route.params.phone,
              correct_user: this.$route.params.correct_user,
              record_id: this.$route.params.record_id,
              exercise_id: this.$route.params.exercise_id,
              object_type: this.$route.params.object_type,
              correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
            }).then((res) => {
              console.log('返回数据', res.data)
              console.log('练习册作业跳转接口：/api/admin/exercise/getExerciseRecordInfo')
              if(res.retcode == 0){
                const view = this.$router.resolve({
                  path: `/homework-info/${res.data.object_id}/${res.data.record_id}/${res.data.tiku_user_id}/${res.data.object_type}/${res.data.exercise_id}/${res.data.assign_correct_user}/${res.data.sso_id}/0/''/0/${res.data.is_release}/${res.data.is_reject}?homework_type=${res.data.homework_type}&correct_from=${res.data.correct_from}`
                })
                window.location.href = view.href
              } else {
                alert(res.message)
              }
            })
          }
        }
      },
      created(){
        this.jw_enter()
      }
    }
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/jw-enter/index.vue